/**
 * Quick View.
 *
 * @version 1.0.0
 * @since 1.0.0
 *
 */

'use strict';

class RisingBambooQuickView {
	constructor() {
		jQuery( document ).on(
			'click touch',
			'.quick-view-button',
			function ( e ) {
				e.preventDefault();
				const $this = jQuery( this );
				const $productId = jQuery( this ).data( 'product-id' );
				$this.addClass( 'quick-view-loading' );
				jQuery.ajax( {
					url: window.rbb_vars.ajax_url,
					data: {
						action: 'rbb_product_quick_view',
						product_id: $productId,
						nonce: window.rbb_vars.nonce,
					},
					success: ( { result } ) => {
						$this.removeClass( 'quick-view-loading' );
						const wrap = $this.parent();
						wrap.append( result );
						const $modalId = wrap
							.find( '.quick-view-product-wrap' )
							.attr( 'id' );
						window.RisingBambooModal.modal( '#' + $modalId );
						jQuery( document.body ).triggerHandler(
							'rbb-quick-view-loaded',
							[ $this, $modalId ]
						);
					},
					error( errorThrown ) {
						// eslint-disable-next-line no-console
						console.info( errorThrown );
					},
				} );
			}
		);
	}
}

new RisingBambooQuickView();

// export default RisingBambooQuickView;
